// `slide-closing`: "> Slide: Vibe coding at Northrop" (docs/PRESENTATION.md, "Wrapping up") — the
// closing framing slide, beat-manifest's "Vibe coding at Northrop — the closing framing slide".
//
// It carries the wordmark, like the cover does: this is the slide that names the company, and a
// deck that opens on the mark and closes on the words alone reads as unfinished from the back of
// the room.

import type { ReactElement } from 'react';
import { SlideFrame } from './SlideFrame';
import { SLIDE_SCALE } from './scale';
import { CLOSING_TITLE } from './content';

export function ClosingSlide(): ReactElement {
  return (
    <SlideFrame center>
      <h1
        style={{
          fontFamily: 'var(--font-display)',
          fontWeight: 600,
          fontSize: SLIDE_SCALE.hero,
          color: 'var(--deck-ink)',
          lineHeight: 'var(--leading-tight)',
          letterSpacing: '-0.02em',
          margin: 0,
        }}
      >
        {CLOSING_TITLE}
      </h1>
    </SlideFrame>
  );
}
